<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/logo.png" alt="Logo" />
          
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/">Home</el-menu-item>
          <el-menu-item index="/goin"> Cost Optimization</el-menu-item>
          <el-menu-item index="/case">Line Card</el-menu-item>
          <el-menu-item index="/download">Contact Us</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>Contact Us</p>
              <p>Skype：sales01@genuineic.com</p>
              <p>📩：easonchan@genuineic.com</p>
              <p>🧑：Eason Chen / Jeeny Yan</p>
              <p>📍：UNIT 1406B, 14/F, THE BELGIAN BANK BUILDING, NOS.721-725 NATHAN ROAD, KOWLOON, HONG KONG</p>
            </li>
          </ul>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive !== key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
  w: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 20px;
  height: 100px; /* 增加导航栏高度 */
 
  .logo {
    img {
      max-width: 100%; /* 适应宽度 */
      height: 90px; /* 增大高度 */
      margin-top: 20px;
    }
  }
}

.el-menu-demo {
  position: relative; /* 使下划线可以定位 */

  .el-menu-item {
    font-size: 28px; /* 增大字体尺寸 */
    padding: 20px 20px; /* 调整内边距，确保下划线不重叠 */
    position: relative; /* 使下划线相对于菜单项定位 */

    &:hover {
      background-color: #f2f2f2;
      border-radius: 4px;
    }

    &.is-active::after { /* 下划线样式 */
      content: '';
      position: absolute;
      bottom: -11px; /* 调整下划线位置 */
      left: 0;
      right: 0;
      height: 4px; /* 下划线高度 */
      background-color: #14679f; /* 下划线颜色 */
    }
  }
}



.footer {
  width: 100%;
  background-color: #14679f;
  color: #f7f7f7;

  &-content {
    width: 100%;
    max-width: 1240px;
    margin: 0 auto;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .content-nav {
      display: flex;
      flex-direction: column;
      p {
        font-size: 22px; /* 增大字体尺寸 */
        color: #d4edff;
        padding: 10px 0;
      }
      span {
        font-weight: 300;
        padding: 5px 0;
      }
    }
  }
}
</style>
